<template>
  <div>
    <div class="document-wrapper">
      <div class="document" @click="showComment = !showComment">

        <template v-if="isImage()">
          <el-image
              @click.stop="openFile()"
              class="images-content"
              fit="cover"
              :src="getUrlPhoto()"
          >
            <div slot="error" class="images-content_error">
              <i class="el-icon-picture-outline"></i> Ошибка загрузки
            </div>
            <div slot="placeholder" class="images-content_loading">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </template>
        <template v-else>

          <div @click.stop="openFile" class="document__icon">
            <file-icon></file-icon>
          </div>
        </template>

        <div class="document__title">
        <span v-if="editable"  @click.stop="">

          <el-input v-model="fileName"></el-input>
        </span>
          <span v-else>{{ fileName }}</span>
        </div>

        <div class="document__type text-block">
          <template>
            <div class="text-block__title">Тип документа</div>
            <div class="text-block__subtitle">{{ document.document_type.title }}</div>
          </template>
        </div>

        <div class="document__date text-block">
          <div class="text-block__title">Время загрузки</div>
          <div class="text-block__subtitle"><i class="el-icon-time"></i> {{ $root.timeIso(document.download_at) }}</div>
        </div>

        <div class="document__buttons">

          <template v-if="!editable">
            <i :style="{'color' : comment ? '#32E6BE' : ''}" @click.stop="showComment = !showComment"
               class="el-icon-chat-dot-round"></i>

            <i  @click.stop="editable = !editable"
               class="el-icon-edit"></i>

            <i
                @click.stop="fileDownload"
                :class="downloadLoading ? 'el-icon-loading' : 'el-icon-download'"
            />
          </template>
          <template v-else>
            <el-button @click.stop="save" type="primary" size="mini" :loading="loading">Сохранить</el-button>
          </template>

        </div>
      </div>

      <div v-if="showComment" class="comment">
        <el-input
            type="textarea"
            autosize
            placeholder="Напишите короткий комментарий..."
            class="comment__input"
            v-model.lazy="comment"
        />
        <div class="btns">
          <el-button @click="save" type="primary" size="mini" :loading="loading">Сохранить</el-button>
          <el-button size="mini" :disabled="loading">Отмена</el-button>
        </div>

      </div>


    </div>
    <file-viewer
        :file="document.file"
        :visible="isVisibleFileViewer"
        @close="isVisibleFileViewer = false"
    />
  </div>
</template>

<script>
import FileViewer from "@/views/cpanel/visit/modal/FileViewer"
import FileIcon from "@/components/icons/File"

export default {
  name: "DocumentItem",
  data() {
    return {
      comment: this.document.comment,
      fileName: this.document.title,
      loading: false,
      showComment: !!this.document.comment,
      editable: false,
      downloadLoading: false,
      isVisibleFileViewer: false,
    }
  },
  components: {
    FileViewer,
    FileIcon
  },
  props: {
    document: {},
    user: {}
  },
  watch: {},
  computed: {},
  methods: {
    save() {
      this.loading = true

      let payLoad = {
        title: this.fileName,
        comment: this.comment
      }

      this.$api.documents
          .editFileData(this.user, this.document.id, payLoad)
          .then(() => {

            this.$notify.success({
              title: "Удачно обновлено",
            })
            this.editable = false

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка сохранения 😕",
              message: response,
            })
          })
          .finally(() => {
            this.loading = false
            this.showComment = false
          })

    },
    isImage() {
      let type = this.document.file.ext
      return type === "jpeg" || type === "jpg" || type === "png"
    },
    getUrlPhoto() {
      return this.$root.getUrlPhoto(this.document.file.link.get)
    },
    openFile() {
      this.isVisibleFileViewer = true
    },
    fileDownload() {
      if (this.downloadLoading) return

      this.downloadLoading = true

      this.$api.devices
          .fileDownload(this.document.file.id)
          .then((response) => {


            const downloadFile = require("js-file-download")
            downloadFile(response.data, this.document.file.full_title)

            this.downloadLoading = false
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки файла 😕",
              message: response,
            })
          })
    }
  }
}
</script>

<style scoped lang="scss">
.document-wrapper {
  background: #fff;
  border-radius: 6px;
  margin: 12px 0;

  transition: all ease .2s;

  &:hover {
    box-shadow: 0 2px 4px rgba(55, 71, 79, 0.16),
    0 4px 8px rgba(55, 71, 79, 0.08);
  }

}

.document {
  padding: 0 23px;
  height: 60px;


  display: flex;
  justify-content: space-between;
  align-items: center;

  &__icon {
    width: 26px;
    font-size: 26px;
  }

  &__title {
    margin-left: 23px;
    flex: 1;

    font-size: 13px;
    line-height: 16px;


    color: #111;

  }

  &__type {
    min-width: 150px;
    margin-left: 30px;
  }

  &__date {
    margin-left: 30px;

  }

  &__buttons {
    margin-left: 30px;

    i {
      margin-left: 10px;
      transition: all .3s ease;
      color: #000000;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #32E6BE;
      }

    }
  }

}


.text-block {
  font-size: 13px;
  line-height: 16px;

  &__title {
    color: #8E8E93;
  }

  &__subtitle {
    color: #111;
    padding: 2px 0;
  }
}


.images-content {
  width: 40px;
  height: 40px;

  cursor: pointer;
  border-radius: 4px;

  transition: all .2s ease;

  &:hover {
    opacity: .8;
  }

  &_name {

  }

  &_loading {
    width: 40px;
    height: 40px;

    text-align: center;
    background: #e3e3e3;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.comment {
  padding: 16px;
  border-top: 1px solid #E4E7ED;

}

.btns {
  margin-top: 12px;
  text-align: right;
}

</style>
